export const MEMBERS_REQUEST = 'MEMBERS_REQUEST'
export const MEMBERS_SUCCESS = 'MEMBERS_SUCCESS'
export const MEMBERS_ERROR = 'MEMBERS_ERROR'
